import Vue from 'vue';
import App from './App.vue';
import Router from 'vue-router'
import store from './store';
// import './registerServiceWorker';

import _ from 'lodash'
import VueMarkdown from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js'
import Vue2Filters from 'vue2-filters'
import Meta from 'vue-meta'

Vue.use(Router)


let a = { base: ['tests'], admin: store.state.components['admin'], display: store.state.components['display'], instance: store.state.components['instance'], uxui: store.state.components['uxui'], widgets: store.state.components['widgets'] }
let imp = {}
let props = {}
Object.keys(a).forEach((k) => {
  a[k].map(async (comp) => {
    imp[comp] = () => import('./components/' + (k === 'base' ? comp : k + '/' + comp))
    Vue.component(comp, await imp[comp])
    let compdetails = await imp[comp]()
    props[comp] = compdetails.default.props ? compdetails.default.props : {}
  })
})

Vue.use(Vue2Filters)
Vue.use(_)
Vue.use(Meta)
Vue.component('vue-markdown', VueMarkdown)

const router = new Router({
  routes: [
    {
      path: '/layout',
      name: 'layout',
      component: imp.layout,
      props: true
    }, {
      path: '/auth',
      name: 'auth',
      component: imp.login
    },
    {
      path: '/',
      name: 'home',
      component: imp.home,
      props: true
    },
    {
      path: '/hello',
      name: 'hello',
      component: imp.hello,
      props: true
    },
    {
      path: '/new',
      name: 'new',
      component: imp.createitem
    },
    {
      path: '/new/:nType',
      name: 'newtype',
      component: imp.createitem,
      props: true
    },
    {
      path: '/message/:messageid',
      name: 'single-message',
      component: imp.message,
      props: true
    },
    {
      path: '/messages',
      name: 'messages',
      component: imp.message,
      props: true
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: imp.notifications,
      props: true
    },
    {
      path: '/page/:pagetitle',
      name: 'page',
      component: imp.pages,
      props: true
    },
    {
      path: '/onboard',
      name: 'onboard',
      component: imp.onboard,
      props: true
    },
    {
      path: '/functions',
      name: 'functions',
      component: imp.function,
      props: true
    },
    {
      path: '/profile',
      name: 'profile',
      component: imp.profile,
      props: true
    },
    {
      path: '/profile/:id',
      name: 'userprofile',
      component: imp.profile,
      props: true
    },
    {
      path: '/complete-signup',
      name: 'Complete Signup',
      component: imp.completesignup
    },
    {
      path: '/list/:type',
      name: 'list',
      component: imp.browse,
      props: true
    },
    {
      path: '/tags/:type/:tag',
      name: 'tags',
      component: imp.browse,
      props: true
    },
    {
      path: '/tests',
      name: 'tests',
      component: imp.tests,
      props: true
    },
    {
      path: '/api',
      name: 'api',
      component: imp.api,
      props: true
    },
    {
      path: '/i/:type/:iitemid',
      name: 'single',
      component: imp.single,
      props: true
    },
    {
      path: '/admin',
      name: 'admin',
      component: imp.admin
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      component: imp.dashboard
    },
    {
      path: '/xmbl/:mn',
      name: 'xmbl',
      component: imp.xmbl,
      props: true
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: imp.wallet,
      props: true
    },
    {
      path: '/orders',
      name: 'orders',
      component: imp.orders,
      props: true
    },
    {
      path: '/orders/:orderId',
      name: 'Order',
      component: imp.orders,
      props: true
    },
    {
      path: '/sales',
      name: 'sales',
      component: imp.sales,
      props: true
    },
    {
      path: '/sales/:orderId',
      name: 'Sale',
      component: imp.sales,
      props: true
    }
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    var element = document.getElementById("main") || document.getElementById("app");
    element && element.scrollIntoView();
    return { x: 0, y: 0, savedPosition }
  }
});

Vue.config.productionTip = false;
Object.defineProperty(Vue.prototype, '$_', { value: _ });
Object.defineProperty(Vue.prototype, '$cp', { value: props }); 

let app = new Vue({
  metaInfo() {
    return {
      title: this.$store.state.app.basics['app name'] ? this.$store.state.app.basics['app name'] : 'Create an app',
      meta: [
        { vmid: 'description', name: 'description', content: this.$store.state.app.basics.mission ? this.$store.state.app.basics.mission : 'Make your dreams come true.' }
      ]
    }
  },
  methods: {
    handleKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.$store.commit('closeAll', {only:[], except:[]})
      }
    }
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app');
Vue.config.devtools = true;
window.addEventListener('keyup', function (e) {
  app.handleKey(e)
});